import api from "./index";

export interface EducationalResourceData {
  id?: string;
  title: string;
  description: string;
  category: string;  
  clinicId: string;
  replaceIndex : 0
  videolink?: string;  
}

export interface EducationalResourcePaginationPayload {
  curPage: number;
  perPage: number;
  sortBy: string;
  direction: string;
  whereClause?: Array<{ key: string; value: string; operator: string }>;
}

export const paginateEducationalResources = async (
  payload: EducationalResourcePaginationPayload
) => {
  return api.post("/educational-resources/pagination", payload);
};

export const getEducationalResourceById = async (id: string) => {
  return api.get(`/educational-resources/getone/${id}`);
};

export const deleteEducationalResourceVideo = async (id: string) => {
  return api.get(`/educational-resources/delete-videos/${id}`);
};

export const deleteEducationalResource = async (id: string) => {
  return api.get(`/educational-resources/delete/${id}`);
};

export const getAllEducationalResources = async () => {
  return api.get("/educational-resources/getall");
};

export const createOrUpdateEducationalResource = async (
  data: EducationalResourceData,
  videos: File[] = []
) => {
  const formData = new FormData();
  formData.append("data", JSON.stringify(data));
  videos.forEach((file) => {
    formData.append("videos", file);
  });

  return api.post("/educational-resources/create-update", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export default {
  paginateEducationalResources,
  getEducationalResourceById,
  deleteEducationalResource,
  deleteEducationalResourceVideo,
  createOrUpdateEducationalResource,
  getAllEducationalResources,
};


